// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index.js'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	template: '<App/>',
	components: { App }
});

// 解决刷新页面vuex消失的问题
if (window.sessionStorage.getItem("userInfo")) {
	store.dispatch("setUserInfo", JSON.parse(window.sessionStorage.getItem("userInfo")));
}

//若未登录则先去登录
router.beforeEach((to, from, next) => {
	console.log(store.getters.getUserInfo);
	// getUserInfo
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (!store.getters.getUserInfo) {
			router.push({
				name: 'login',
				query: {
					'returnUrl': to.fullPath
				}
			})
		} else {
			next();
		}
	} else {
		next();
	}
})  


// WEBPACK FOOTER //
// ./src/main.js